import CadastroHeader from "../../components/CadastroHeader/CadastroHeader";
import ButtonPages from "../../components/ButtonPages/ButtonPages";
import { PARAMETER_MAP } from "../../util/PARAMETER_MAP";
import styles from "../../styles/styles";

import { Box, Paper, Button } from "@mui/material";
import { useEffect, useRef, useState } from "react";

import { api } from "../../services/apiService";
import { useAuth } from "../../contexts/AuthContext";

import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import ParamAutocomplete from "../../components/ParamAutocomplete/ParamAutocomplete";
import "./NotificacoesPage.css";
import { useMinhaLinhaOperador } from "../../app/hooks/useMinhaLinhaOperador";
import { useTrens } from "../../app/hooks/useTrens";
import Modal from "../../components/Modal/Modal";
export default function NotificacoesPage() {
  const { userInfo } = useAuth();
  const { idLinha, loading: linhaLoading } = useMinhaLinhaOperador(userInfo);
  const operadorLinhaId = idLinha;
  const isVisualizador = !operadorLinhaId;
  const isOperadorAtivo = userInfo?.roleId === 3 && !isVisualizador;
  const [total, setTotal] = useState(0);
  const [notifications, setNotifications] = useState([]);
  const [usuarios, setUsuarios] = useState({});
  const [loading, setLoading] = useState(false);

  const { trens, error: trensError } = useTrens();
  const [emailsUsuarios, setEmailsUsuarios] = useState([]);
  const [errorModal, setErrorModal] = useState({ show: false, message: "" });

  const [filtros, setFiltros] = useState({
    trem: "",
    parametro: "",
    carro: "",
    eventoInicio: "",
    eventoFim: "",
    cienteInicio: "",
    cienteFim: "",
    usuario: "",
    lidas: false,
    naoLidas: false
  });

  const [page, setPage] = useState(1);
  const pageSize = 5;


  const formatarData = (timestamp) => {
    if (!timestamp) return "--";

    const date =
      timestamp < 1e12
        ? new Date(timestamp * 1000)
        : new Date(timestamp);

    return date.toLocaleString("pt-BR", {
      dateStyle: "short",
      timeStyle: "short"
    });
  };

  const formatarDataCompleta = (dateString) => {
    if (!dateString) return "--";

    return new Date(dateString).toLocaleString("pt-BR", {
      timeZone: "America/Sao_Paulo",
      dateStyle: "short",
      timeStyle: "short"
    });
  };

  const getIcon = (category) => {
    if (category === 2) return <ErrorOutlineIcon color="error" />;
    if (category === 3) return <WarningAmberIcon sx={{ color: "#f59e0b" }} />;
    return <InfoOutlinedIcon color="primary" />;
  };

  const formatDetalhes = (n) => {
    const paramMeta = PARAMETER_MAP?.[String(n.parameterId)];

    return {
      trem: n.tremNome ?? n.tremId ?? "--",
      carro: n.carro ?? "--",
      parametro: paramMeta?.name ?? n.parameterId ?? "--"
    };
  };

  const carregarUsuarios = async (notificacoes) => {
    const ids = [...new Set(notificacoes.map(n => n.usuarioId).filter(Boolean))];
    if (!ids.length) return;

    const responses = await Promise.all(ids.map(id => api.usuario.getById(id)));

    const map = {};
    responses.forEach(res => {
      const user = res.data || res;
      map[user.id] = user.email;
    });

    setUsuarios(map);
  };

  const carregarEmailsUsuarios = async () => {
    try {
      const response = await api.usuario.getEmails();
      setEmailsUsuarios(response?.data || response || []);
    } catch (error) {
      setErrorModal({ show: true, message: "Erro ao carregar e-mails de usuários." });
    }
  };

  const trensDaLinha = operadorLinhaId
    ? trens.filter((t) => t.linhaId === operadorLinhaId)
    : trens;

  const tremSelecionado = trensDaLinha.find((t) => t.nomeCodigo === filtros.trem);

  const opcoesCarro = Array.from(
    { length: tremSelecionado?.quantidadeCarros || 0 },
    (_, i) => i + 1
  );

  const listar = async () => {
    if (linhaLoading) return;
    setLoading(true);

    const filtrosComLinha = { ...filtros };

    if (filtrosComLinha.carro) {
      filtrosComLinha.carro = Number(filtrosComLinha.carro);

      if (isNaN(filtrosComLinha.carro)) {
        filtrosComLinha.carro = undefined;
      }
    }

    if (operadorLinhaId) {
      filtrosComLinha.linhaId = operadorLinhaId;
    }

    try {
      const response = await api.notifications.getAll(
        page,
        pageSize,
        filtrosComLinha
      );

      setNotifications(response.data || []);
      setTotal(response.total || 0);

      await carregarUsuarios(response.data || []);
    } catch (error) {
      setErrorModal({ show: true, message: "Erro ao buscar notificações." });
    } finally {
      setLoading(false);
    }
  };

  const marcarComoLida = async (id) => {
    if (isVisualizador) return;

    await api.notifications.markAsRead(id);
    window.dispatchEvent(new Event("notificationUpdated"));
    listar();
  };

  const listarRef = useRef(listar);
  useEffect(() => {
    listarRef.current = listar;
  });

  useEffect(() => {
    carregarEmailsUsuarios();
  }, []);

  useEffect(() => {
    if (trensError) {
      setErrorModal({ show: true, message: trensError });
    }
  }, [trensError]);

  useEffect(() => {
    if (linhaLoading) return;
    listar();
  }, [page, operadorLinhaId, linhaLoading]);
  useEffect(() => {
    setPage(1);
  }, [operadorLinhaId]);
  useEffect(() => {
    const handleUpdate = () => listarRef.current();
    window.addEventListener("notificationUpdated", handleUpdate);
    return () => window.removeEventListener("notificationUpdated", handleUpdate);
  }, []);
  return (
    <Box sx={styles.pageWrapper}>

      <Modal
        show={errorModal.show}
        type="error"
        message={errorModal.message}
        onClose={() => setErrorModal({ show: false, message: "" })}
      />

      <Box component="main" sx={styles.mainContent}>
        <Paper elevation={0} sx={styles.card}>

          <CadastroHeader
            title="Notificações"
            subtitle="Acompanhe alertas do sistema"
          />

          <div className="card-container">
            <div className="card">


              <div className="filters-card">
                <div className="filters-grid">

                  <label className="filter-field">
                    <span>Trem</span>
                    <select
                      value={filtros.trem}
                      onChange={(e) => {
                        const novoTrem = e.target.value;
                        const tremInfo = trensDaLinha.find((t) => t.nomeCodigo === novoTrem);
                        const carroValido =
                          filtros.carro &&
                          tremInfo &&
                          Number(filtros.carro) <= tremInfo.quantidadeCarros;

                        setFiltros({
                          ...filtros,
                          trem: novoTrem,
                          carro: carroValido ? filtros.carro : ""
                        });
                      }}
                    >
                      <option value="">Todos</option>
                      {trensDaLinha.map((t) => (
                        <option key={t.id} value={t.nomeCodigo}>
                          {t.nomeCodigo}
                        </option>
                      ))}
                    </select>
                  </label>

                  <label className="filter-field">
                    <span>Carro</span>
                    <select
                      value={filtros.carro}
                      disabled={!tremSelecionado}
                      onChange={(e) => {
                        setFiltros({ ...filtros, carro: e.target.value });
                      }}
                    >
                      <option value="">
                        {tremSelecionado ? "Todos" : "Selecione um trem"}
                      </option>
                      {opcoesCarro.map((c) => (
                        <option key={c} value={c}>
                          {c}
                        </option>
                      ))}
                    </select>
                  </label>

                  <label className="filter-field">
                    <span>Usuário</span>
                    <select
                      value={filtros.usuario}
                      onChange={(e) => setFiltros({ ...filtros, usuario: e.target.value })}
                    >
                      <option value="">Todos</option>
                      {emailsUsuarios.map((email) => (
                        <option key={email} value={email}>
                          {email}
                        </option>
                      ))}
                    </select>
                  </label>

                  <label className="filter-field">
                    <span>Parâmetro</span>
                    <ParamAutocomplete
                      selectedParam={filtros.parametro}
                      onSelect={(id) =>
                        setFiltros({ ...filtros, parametro: id })
                      }
                    />
                  </label>

                  <label className="filter-field">
                    <span>Evento início</span>
                    <input
                      type="datetime-local"
                      value={filtros.eventoInicio}
                      onChange={(e) =>
                        setFiltros({ ...filtros, eventoInicio: e.target.value })
                      }
                    />
                  </label>

                  <label className="filter-field">
                    <span>Evento fim</span>
                    <input
                      type="datetime-local"
                      value={filtros.eventoFim}
                      onChange={(e) =>
                        setFiltros({ ...filtros, eventoFim: e.target.value })
                      }
                    />
                  </label>

                  <label className="filter-field">
                    <span>Ciência início</span>
                    <input
                      type="datetime-local"
                      value={filtros.cienteInicio}
                      onChange={(e) =>
                        setFiltros({ ...filtros, cienteInicio: e.target.value })
                      }
                    />
                  </label>

                  <label className="filter-field">
                    <span>Ciência fim</span>
                    <input
                      type="datetime-local"
                      value={filtros.cienteFim}
                      onChange={(e) =>
                        setFiltros({ ...filtros, cienteFim: e.target.value })
                      }
                    />
                  </label>
                  <label className="filter-field checkbox-field">
                    <span>Status</span>

                    <div className="checkbox-group">
                      <label>
                        <input
                          type="checkbox"
                          checked={filtros.naoLidas}
                          onChange={(e) =>
                            setFiltros({ ...filtros, naoLidas: e.target.checked })
                          }
                        />
                        Não lidas
                      </label>

                      <label>
                        <input
                          type="checkbox"
                          checked={filtros.lidas}
                          onChange={(e) =>
                            setFiltros({ ...filtros, lidas: e.target.checked })
                          }
                        />
                        Lidas
                      </label>
                    </div>
                  </label>
                </div>

                <div className="filters-actions">
                  <Button
                    variant="contained"
                    onClick={() => {
                      if (page !== 1) {
                        setPage(1);
                      } else {
                        listar();
                      }
                    }}
                  >
                    Buscar
                  </Button>
                </div>
              </div>
              {operadorLinhaId && (
                <div style={{ marginBottom: 10, fontSize: 12, color: "#666" }}>
                  Exibindo apenas notificações da sua linha
                </div>
              )}
              {notifications.map((n) => {
                const d = formatDetalhes(n);

                return (
                  <div key={n.id} className={`notificacao-card ${n.readAt ? "lida" : "nao-lida"}`}>
                    <div className="notificacao-header">
                      <div className="notificacao-titulo">
                        {getIcon(n.category)}
                        <span>Alerta</span>
                      </div>
                      {!n.readAt && <span className="notificacao-badge">Nova</span>}
                    </div>

                    <div className="notificacao-body">
                      <div><strong>Trem:</strong> {d.trem}</div>
                      <div><strong>Carro:</strong> {d.carro}</div>
                      <div><strong>Parâmetro:</strong> {d.parametro}</div>
                    </div>

                    <div className="notificacao-footer">
                      <div><strong>Evento:</strong> {formatarData(n.messageTimestamp)}</div>
                      {n.readAt && (
                        <div><strong>Ciente:</strong> {formatarDataCompleta(n.readAt)}</div>
                      )}
                      <div>
                        <strong>Usuário:</strong>{" "}
                        {n.usuarioId
                          ? usuarios[n.usuarioId] || "..."
                          : n.readAt
                          ? "Ciência automática pelo sistema - repetição de alarme em sequência"
                          : "Não Lida"}
                      </div>
                    </div>

                    {!n.readAt && isOperadorAtivo && (
                      <div className="notificacao-acao">
                        <Button size="small" onClick={() => marcarComoLida(n.id)}>
                          Marcar como lida
                        </Button>
                      </div>
                    )}
                  </div>
                );
              })}
              {!loading && notifications.length === 0 && (
                <div
                  style={{
                    marginTop: 20,
                    padding: 20,
                    textAlign: "center",
                    fontSize: 14,
                  }}
                >
                  Nenhum registro a ser exibido.
                </div>
              )}
              {total > 0 && (
                <ButtonPages
                  paginaAtual={page}
                  setPaginaAtual={setPage}
                  totalCount={total}
                  itensPorPagina={pageSize}
                />
              )}

            </div>
          </div>

        </Paper>
      </Box>
    </Box>
  );
}